import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Marquee = ({ items, dark = false, slow = false }) => (
  <div className={`pause-on-hover overflow-hidden ${dark ? "bg-[#0A1128]" : "bg-white"}`}>
    <div className={`flex w-max ${slow ? "animate-marquee-slow" : "animate-marquee"}`}>
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
          {items.map((item, i) => (
            <span
              key={`${dup}-${i}`}
              className={`flex items-center whitespace-nowrap font-display text-2xl uppercase tracking-tight md:text-4xl ${
                dark ? "text-white/10" : "text-slate-400"
              }`}
            >
              <span className="px-8">{item}</span>
              <span className={`text-lg ${dark ? "text-[#1D4ED8]/40" : "text-[#1D4ED8]/30"}`}>&#9679;</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const Overline = ({ children, className = "", dark = false }) => (
  <p
    className={`font-display text-xs font-semibold uppercase tracking-[0.25em] ${
      dark ? "text-[#4b6bd6]" : "text-[#1D4ED8]"
    } ${className}`}
  >
    {children}
  </p>
);

export const PrimaryButton = ({ children, onClick, to, className = "", testId, light = false }) => {
  const palette = light
    ? "bg-white text-[#0A1128] hover:bg-[#1D4ED8] hover:text-white"
    : "bg-[#0A1128] text-white hover:bg-[#1D4ED8]";
  const cls = `group inline-flex items-center gap-3 px-7 py-4 font-display text-sm uppercase tracking-widest transition-colors ${palette} ${className}`;
  const inner = (
    <>
      {children}
      <span className="link-arrow">
        <ArrowRight size={18} />
      </span>
    </>
  );
  if (to)
    return (
      <Link to={to} data-testid={testId} className={cls}>
        {inner}
      </Link>
    );
  return (
    <button onClick={onClick} data-testid={testId} className={cls}>
      {inner}
    </button>
  );
};

export const OutlineButton = ({ children, onClick, to, className = "", testId, dark = false }) => {
  const base = dark
    ? "border border-white/40 text-white hover:bg-white hover:text-[#0A1128]"
    : "border border-[#0A1128] text-[#0A1128] hover:bg-[#0A1128] hover:text-white";
  const cls = `group inline-flex items-center gap-3 px-7 py-4 font-display text-sm uppercase tracking-widest transition-colors ${base} ${className}`;
  const inner = (
    <>
      {children}
      <span className="link-arrow">
        <ArrowRight size={18} />
      </span>
    </>
  );
  if (to)
    return (
      <Link to={to} data-testid={testId} className={cls}>
        {inner}
      </Link>
    );
  return (
    <button onClick={onClick} data-testid={testId} className={cls}>
      {inner}
    </button>
  );
};

// Inner page hero band
export const PageHero = ({ overline, title, intro, image }) => (
  <section className="relative overflow-hidden bg-[#0A1128] pt-36 pb-20 text-white md:pt-44 md:pb-28">
    <div className="noise" />
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-[#0A1128]/70" />
      </div>
    )}
    <div className="container-x relative z-10">
      <Overline dark>{overline}</Overline>
      <h1 className="mt-5 max-w-4xl font-display text-5xl font-bold uppercase leading-none tracking-tighter md:text-7xl">
        {title}
      </h1>
      {intro && <p className="speakable mt-8 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{intro}</p>}
    </div>
  </section>
);
